import React from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import PriorityHighOutlined from '@mui/icons-material/PriorityHighOutlined';
import { RISK_STATUS_OPTIONS, RisksType } from 'domain/shared/newProject';
import { AppIcon, Tooltip } from 'framework/ui/mui-builder';

interface RiskSectionHeaderProps {
  data: RisksType;
  actions?: React.ReactNode;
  isEdit?: boolean;
}

const RiskSectionHeader = ({ data, actions, isEdit = false }: RiskSectionHeaderProps) => {
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" gap={1} sx={{ width: '100%' }}>
          <Box display="flex" alignItems="center" flexDirection={'row'} gap={2} sx={{ width: '60%' }}>
            {!isEdit ? (
              <>
                {data.title!.length > 150 ? (
                  <Tooltip title={data?.title}>
                    <Typography
                      variant="h1"
                      color="brand"
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 1.2,
                        wordBreak: 'break-word',
                      }}
                    >
                      {`${data?.alias}: ${data?.title}`}
                    </Typography>
                  </Tooltip>
                ) : (
                  <Typography
                    variant="h1"
                    color="brand"
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      lineHeight: 1.2,
                      wordBreak: 'break-word',
                    }}
                  >
                    {`${data.alias}: ${data.title}`}
                  </Typography>
                )}
                {data?.isIncludedInCustomerReport ? (
                  <Tooltip title="Risk is included in customer's report">
                    <AppIcon icon="verified-document" viewBox="0 0 16 16" color="success" />
                  </Tooltip>
                ) : (
                  <Tooltip title="Risk is not included in customer's report" color="textSecondary">
                    <AppIcon icon="rejected-document" viewBox="0 0 16 16" />
                  </Tooltip>
                )}
                <Badge
                  color="error"
                  sx={{ fontSize: '20px', '.MuiBadge-badge': { position: 'relative', transform: 'none' } }}
                  badgeContent={RISK_STATUS_OPTIONS[data.status!]}
                />
                {data?.isEscalated ? <PriorityHighOutlined color="error" /> : null}
              </>
            ) : null}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>{actions}</Box>
        </Box>
      </Box>
    </>
  );
};

export default RiskSectionHeader;
